import { render, staticRenderFns } from "./UiBreadcrumb.vue?vue&type=template&id=6307e8d3"
import script from "./UiBreadcrumb.vue?vue&type=script&lang=js"
export * from "./UiBreadcrumb.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports